module.exports = __webpack_public_path__ + "static/logo-c6d7033b609b5bcdc32afa5b7597134d.svg";